function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as constants from '../../../constants';
import messages from '../../../messages';
import GdprExportModal from '../GdprExportModal';
var _React_PureComponent;
class ExportData extends (_React_PureComponent = React.PureComponent) {
    render() {
        return /*#__PURE__*/ _jsxs("section", {
            "data-testid": "export-personal-data",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "section__header",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.exportData))
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "section__intro",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.exportData))
                }),
                /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.exportData,
                    className: "btn--filled",
                    // isInProgress={false}
                    onClick: ()=>this.props.onOpenModal(constants.GDPR_EXPORT_MODAL)
                }),
                /*#__PURE__*/ _jsx(GdprExportModal, {})
            ]
        });
    }
}
_define_property(ExportData, "propTypes", {
    onOpenModal: PropTypes.func
});
const mapDispatchToProps = (dispatch)=>({
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId))
    });
const ConnectedExportData = connect(null, mapDispatchToProps)(ExportData);
export default ConnectedExportData;
